import group12 from '../assets/Group-12.png'
const Navigation = () => {
  return (
    <header className="relative z-20 md:bg-black w-full">
      <div className="container flex justify-between items-center gap-[10px] h-[70px] sm:h-[90px]">
        <img src={group12} alt="Logo"
          className="w-[182px] sm:w-[230px]" />
      </div>
    </header>

  );

};

export default Navigation;